import * as React from 'react';
import { SVGProps } from 'react';

const IconAlignBlocksRightSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2h2v12h-2V2zm-1 2H1v3h10V4zm0 5H4v3h7V9z"
    />
  </svg>
);
export default IconAlignBlocksRightSizeS;
